import eventBus from '@/helpers/eventBus';
import AGREGAR_CONTRATO_SUB_TEMA from '@/graphql/mutations/administracion/contratos/contrato/subtemas/agregarContratoSubTema.gql';
import ACTUALIZAR_CONTRATO_SUB_TEMA from '@/graphql/mutations/administracion/contratos/contrato/subtemas/actualizarContratoSubTema.gql';
import REMOVER_CONTRATO_SUB_TEMA from '@/graphql/mutations/administracion/contratos/contrato/subtemas/removerContratoSubTema.gql';

export default {
  methods: {
    // Agregar Sub Tema
    async mixAgergarSubTema() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_SUB_TEMA,
          variables: {
            subTema: this.subTema,
          },
          // update: (store, { data: { agregarContratoSubTema } }) => {
          //   const query = {
          //     query: CONTRATO_SUB_TEMAS,
          //     variables: {
          //       idTema: this.idTema,
          //     },
          //   };
          //   const { contratoSubTemas } = store.readQuery(query);
          //   const contratoSubTemasCopia = contratoSubTemas.slice();
          //   contratoSubTemasCopia.push(agregarContratoSubTema);
          //   store.writeQuery({
          //     ...query,
          //     data: {
          //       contratoSubTemas: contratoSubTemasCopia,
          //     },
          //   });
          // },
        })
        .then(() => {
          this.mixMensajeSuccess();
          eventBus.$emit('contrato-subtema-agregado');
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.$emit('actualizar');
      this.cerrar();
    },
    // Actualizar Sub Tema
    async mixActualizarSubTema() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CONTRATO_SUB_TEMA,
          variables: {
            id: this.contratoSubTemaEditar.id,
            subTema: this.subTema,
          },
          // update: (store, { data: { actualizarContratoSubTema } }) => {
          //   const query = {
          //     query: CONTRATO_SUB_TEMAS,
          //     variables: {
          //       idTema: this.contratoSubTemaEditar.idTema,
          //     },
          //   };
          //   const data = store.readQuery(query);
          //   const { contratoSubTemas } = data;
          //   const index = contratoSubTemas
          //     .findIndex((contratoSubTema) => contratoSubTema.id
          //     === actualizarContratoSubTema.id);
          //   if (index !== -1) {
          //     contratoSubTemas.splice(index, 1, actualizarContratoSubTema);
          //   }
          //   store.writeQuery({ ...query, data });
          // },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.$emit('actualizar');
      this.cerrar();
    },
    // Eliminar Sub Tema
    async mixEliminarSubTema() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CONTRATO_SUB_TEMA,
        variables: {
          id: this.contratoSubTemaEliminar.id,
        },
        // update: (store) => {
        //   const query = {
        //     query: CONTRATO_SUB_TEMAS,
        //     variables: {
        //       idTema: this.contratoSubTemaEliminar.idTema,
        //     },
        //   };
        //   const data = store.readQuery(query);
        //   const { contratoSubTemas } = data;
        //   const index = contratoSubTemas
        //     .findIndex((subTema) => subTema.id === this.contratoSubTemaEliminar.id);
        //   if (index !== -1) {
        //     contratoSubTemas.splice(index, 1);
        //   }
        //   store.writeQuery({ ...query, data });
        // },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.$emit('actualizar');
      this.cerrar();
    },
  },
};
